import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//     isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//       const isSubmitted = form && form.submitted;
//       return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
//     }
//   }

@Component({
    selector: 'charity-check-modal',
    templateUrl: '././charity-check.component.html',
    styleUrls: ['././charity-check.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharityChecktModalComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    charityCheckForm!: FormGroup;
    einNumber!: string;
    // matcher = new MyErrorStateMatcher();

    constructor(
        private dialogRef: MatDialogRef<CharityChecktModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder,
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
    ) {
        this.title = data.title;
        this.message = data.message;
    }

    ngOnInit() {
        this.createForms();
    }

    private createForms(): void {
        this.charityCheckForm = this.fb.group({
            // ein: ['611257368', [Validators.required, Validators.maxLength(9), Validators.pattern(new RegExp(/^\d{9}/))]]
            ein: ['', [Validators.required, Validators.maxLength(10), Validators.pattern(new RegExp(/^\d{2}-\d{7}/))]]
        });

        // this.charityCheckForm.get('ein').valueChanges.subscribe((value: string) => {
        //     if(value.length==9) {
        //         this.einNumber = value.slice(0,2)+'-'+value.slice(2,9)
                
        //     }
        // });
    }

    onSubmit() {
        // // console.log(this.einNumber)
        // console.log(this.charityCheckForm.value)
        this.dialogRef.close(this.charityCheckForm.value);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnDestroy() {

    }

}

